import ApiClient from './ApiClient';

class Companies extends ApiClient {
  constructor() {
    super('companies', { accountScoped: true });
  }
}

export default new Companies();
